import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PRODUCT_SCREENSHOTS } from "../ProductPages/productScreenshots";

const flyers = [
  {
    title: "Signups",
    body: "Let bowlers register themselves. They pick a squad, join a waitlist if it is full, and hold a spot for 24 hours.",
    to: "/bowling-tournament-signups",
    shot: PRODUCT_SCREENSHOTS.signups,
  },

  {
    title: "Card payments",
    body: "Turn on Pay now so bowlers pay by card when they sign up. You still take cash at the desk. Paid, Held, and Due stay on the same roster.",
    to: "/bowling-tournament-card-payments",
    shot: PRODUCT_SCREENSHOTS.payments,
  },

  {
    title: "Averages",
    body: "Enter the average when you add a team on Scoring, or when the bowler signs up. Verify on Averages. That number follows them on every squad they bowl.",
    to: "/bowling-tournament-averages",
    shot: PRODUCT_SCREENSHOTS.averages,
  },

  {
    title: "Scoring",
    body: "Bowlers watch Standings as you post. The same scores count toward the primary event and side pots.",
    to: "/bowling-tournament-scoring",
    shot: PRODUCT_SCREENSHOTS.scoring,
  },

  {
    title: "Brackets",
    body: "Sell tickets, shuffle, and see who to pay after Game 3. Leftover tickets show as refunds.",
    to: "/bowling-bracket-software",
    shot: PRODUCT_SCREENSHOTS.brackets,
  },

  {
    title: "Payouts",
    body: "Lock prize funds and side pots on Finance, the payout table. Bowlers see the same amounts on Prizes.",
    to: "/bowling-tournament-payouts",
    shot: PRODUCT_SCREENSHOTS.payouts,
  },
];

const FlyerShot = ({ flyer, showTitle = false }) => {
  if (!flyer.shot && !showTitle) return null;

  return (
    <figure>
      <div className="card-board overflow-hidden">
        {showTitle ? (
          <div className="bg-brand-charcoal px-5 py-4">
            <h3 className="font-display font-bold text-brand-cream tracking-tight text-xl">
              {flyer.title}
            </h3>
            <div className="mt-2 h-1 w-12 bg-brand-gold" aria-hidden="true" />
          </div>
        ) : null}
        {flyer.shot ? (
          <img
            src={flyer.shot.src}
            alt={flyer.shot.alt}
            className="w-full aspect-[16/10] object-cover object-top bg-brand-cream"
            width={1600}
            height={1000}
          />
        ) : null}
      </div>
    </figure>
  );
};

const FeatureFlyers = () => {
  const [active, setActive] = useState(0);
  const flyer = flyers[active];

  return (
    <section className="bg-brand-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="border-t border-brand-charcoal/10 pt-16 md:pt-20 pb-16 md:pb-20">
        <h2 className="heading-display text-3xl md:text-4xl">
          Bowling tournament software
        </h2>
        <div className="mt-3 h-1 w-12 bg-brand-gold" aria-hidden="true" />
        <p className="mt-4 text-brand-muted max-w-2xl">
          Signups, scoring, brackets, payouts, and card payments. Same screens
          directors use.
        </p>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <ul className="space-y-1">
            {flyers.map((item, index) => {
              const selected = index === active;
              return (
                <li
                  key={item.title}
                  className={`rounded-lg transition-colors ${
                    selected
                      ? "bg-white border border-brand-charcoal/10 shadow-sm"
                      : "border border-transparent hover:bg-white/60"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setActive(index)}
                    aria-pressed={selected}
                    aria-expanded={selected}
                    className="w-full text-left px-4 py-4"
                  >
                    <h3
                      className={`font-display font-bold tracking-tight text-xl ${
                        selected ? "text-brand-charcoal" : "text-brand-muted"
                      }`}
                    >
                      {item.title}
                    </h3>
                    {selected ? (
                      <div
                        className="mt-2 h-1 w-12 bg-brand-gold"
                        aria-hidden="true"
                      />
                    ) : null}
                  </button>
                  {selected ? (
                    <div className="px-4 pb-4 -mt-1 space-y-4">
                      <div className="lg:hidden">
                        <FlyerShot flyer={item} />
                      </div>
                      <p className="text-brand-muted text-sm leading-relaxed">
                        {item.body}
                      </p>
                      <p>
                        <Link
                          to={item.to}
                          className="inline-flex items-center justify-center rounded-lg border border-brand-charcoal text-brand-charcoal font-display font-bold tracking-wide px-4 py-2 text-sm hover:bg-brand-charcoal hover:text-brand-cream transition-colors"
                        >
                          See {item.title}
                        </Link>
                      </p>
                    </div>
                  ) : null}
                </li>
              );
            })}
          </ul>

          <div className="hidden lg:block lg:sticky lg:top-24">
            <FlyerShot flyer={flyer} showTitle />
          </div>
        </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureFlyers;
